import React, { useState, useEffect } from "react";
import logo from "../../resources/WSW_logo.png";
import { ProgressIndicator } from "@amzn/aws-euc-ui";
import "./style.css";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// This value is taken from Data Plane session launch  p90 latency
// https://w.amazon.com/bin/view/AWS/Services/WorkSpacesWeb/Operations/Dashboards/ServiceHealthDashboard/
const SESSION_START_TIME = 35000;

const Loader = ({ message }) => {
  const { t } = useTranslation();
  const progress = useSpinnerProgress(SESSION_START_TIME);
  const isDeterminateProgressBar =
    message === "Connecting..." && progress < 100;

  // Enum object mapping English messages from AS2 to localized keys
  const MessageEnum = {
    "Connecting...": t("euc.loading.screen.connecting.message"),
    "Resizing...": t("euc.loading.screen.resizing.message"),
    "Reserving your session...": t("euc.loading.screen.reserving.message"),
  };
  const localizedMessage = MessageEnum[message] ?? message;
  return (
    <div className={"euc-loader-container-style"}>
      <ProgressIndicator
        header={
          <div className="euc-loader-header-container">
            <img className="euc-loader-header-image" src={logo} />
          </div>
        }
        indicatorStyle={{
          width: "260px",
        }}
        determinate={isDeterminateProgressBar}
        progress={progress}
        size="cover"
        footer={
          <div className="euc-loader-footer-container">
            {localizedMessage && (
              <span className="euc-loader-footer-span">{localizedMessage}</span>
            )}
          </div>
        }
      />
    </div>
  );
};

const useSpinnerProgress = (time = 0) => {
  const [progress, setProgress] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevNumber) => {
        if (prevNumber === 100) {
          clearInterval(interval);
          return prevNumber;
        }
        return prevNumber + 1;
      });
    }, time / 100);

    return () => clearInterval(interval);
  }, []);

  return progress;
};

Loader.propTypes = {
  message: PropTypes.string.isRequired,
};

export default Loader;
